import type { FieldError } from 'react-hook-form';
import type { TextEditorProps } from '../TextEditor';
import { forwardRef, useState } from 'react';
import { TextEditor } from '../TextEditor';
import { StyledWrapper, StyledErrorMessage, StyledLabel } from './TextEditorWithErrorDisplay.styles';

export type TextEditorWithErrorDisplayProps = {
  error?: FieldError;
  label?: string;
} & TextEditorProps;

export const TextEditorWithErrorDisplay = forwardRef(
  ({ error, label, id, ...props }: TextEditorWithErrorDisplayProps, ref) => {
    const [fieldId] = useState(() => id || Math.random().toString(36).substring(7));

    return (
      <>
        {label && <StyledLabel htmlFor={fieldId}>{label}</StyledLabel>}
        <StyledWrapper hasError={!!error}>
          <TextEditor ref={ref} id={fieldId} {...props} />
        </StyledWrapper>
        {error && <StyledErrorMessage density="sm">{error.message}</StyledErrorMessage>}
      </>
    );
  },
);
